import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { Location } from '../../../types/locations.tsx';
import type { State } from '../state/model.tsx';
import {
	projectsSelector,
	userSelector,
	isPendingSelector,
	recentProjectsLimitSelector,
} from '../state/selectors/index.tsx';
import LocationPicker from './location-picker/index.tsx';

type StateProps = {
	isPending: boolean;
	projects: Location[];
	user: Location;
	recentProjectsLimit: number;
};

const mapStateToProps = (state: State): StateProps => ({
	isPending: isPendingSelector(state),
	projects: projectsSelector(state),
	user: userSelector(state),
	recentProjectsLimit: recentProjectsLimitSelector(state),
});

export default connect(mapStateToProps, {})(LocationPicker);
